/* bl-openchat.js — öffnet den Shopify-Chat von einem beliebigen Button aus.
   Verwendung:  <button data-bl-openchat>…</button>
   Optional:    data-bl-openchat-fallback="#css-selektor"  (Ziel, wenn der Chat nicht aufgeht)

   Warum so umständlich:
   1) Shopify bietet kein öffentliches API zum Öffnen des Chats.
   2) Der Activator liegt NICHT in shopify-chat.shadowRoot, sondern eine Ebene tiefer in
      <shopify-agent-runtime> (exportparts="activator, dialog") -> Tiefensuche nötig.
   3) Der Button rendert, BEVOR sein eigener Handler gebunden ist. Ein einmaliger Klick
      verpufft deshalb wirkungslos -> klicken, Ergebnis prüfen, notfalls erneut klicken.
   Ein generischer button-Fallback wäre falsch: der trifft beim halb geladenen Widget den
   Sign-in-Knopf und öffnet den Chat dann nie.

   ⚠️ 22.09.2026 — Korrektur eines Fehlers, der Kund:innen aus dem Chat geworfen hat:
   Der Activator ist ein TOGGLE. Die alte Fassung hat bis zu 16 Mal im 250-ms-Takt geklickt,
   solange `isOpen()` false meldete — und `isOpen()` meldete praktisch immer false, weil es
   <shopify-agent-runtime> gesucht hat: dieses Element legt Shopify erst beim ERSTEN Öffnen an.
   Auf schnellem Desktop war es nach ~180 ms da (gerade noch unter 250 ms, deshalb fiel es nicht
   auf), auf dem Handy dauert es länger — dann klickte die Schleife weiter und schaltete den Chat
   auf/zu/auf/zu. Für Shopify Inbox sieht jedes Zu wie „Kund:in hat die Unterhaltung verlassen" aus.
   Zwei Änderungen:
   a) `isOpen()` fragt zuerst das Attribut `open` am <shopify-chat> selbst ab (das setzt Shopify
      sofort beim Öffnen), Runtime-Element nur noch als Rückfallebene.
   b) Höchstens 3 Klicks mit 1,5 s Abstand statt 16 Klicks im 250-ms-Takt. Ungerade Zahl mit
      Absicht: sollte die Erkennung irgendwann wieder brechen, endet der Chat OFFEN, nicht zu. */
(function () {
  var MAX_KLICKS = 3;       // höchstens so oft den Activator antippen
  var KLICK_ABSTAND = 1500; // ms, die dem Widget nach jedem Klick zum Öffnen bleiben
  var AUFGEBEN_NACH = 6000; // ms, danach Fallback (zum E-Mail-Formular scrollen)

  function deepFind(root, sel, d) {
    if (!root || d > 6) return null;
    var hit = root.querySelector ? root.querySelector(sel) : null;
    if (hit) return hit;
    var els = root.querySelectorAll ? root.querySelectorAll('*') : [];
    for (var i = 0; i < els.length; i++) {
      if (els[i].shadowRoot) {
        var r = deepFind(els[i].shadowRoot, sel, d + 1);
        if (r) return r;
      }
    }
    return null;
  }
  function chatEl() { return document.querySelector('shopify-chat'); }
  function activator() {
    try {
      var c = chatEl();
      if (!c || !c.shadowRoot) return null;
      return deepFind(c.shadowRoot, '[part~="activator"]', 0);
    } catch (e) { return null; }
  }
  /* Der Activator ist ein Toggle: ist der Chat schon offen, würde ein Klick ihn schließen. */
  function isOpen() {
    try {
      var c = chatEl();
      if (!c) return false;
      if (c.hasAttribute('open')) return true;            // Shopify setzt das sofort beim Öffnen
      var rt = c.shadowRoot && c.shadowRoot.querySelector('shopify-agent-runtime');
      return !!(rt && rt.hasAttribute('open'));           // Rückfallebene für ältere Widget-Stände
    } catch (e) { return false; }
  }
  function fallback(btn) {
    var sel = btn && btn.getAttribute('data-bl-openchat-fallback');
    if (!sel) return;
    var t = document.querySelector(sel);
    if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  function openChat(btn) {
    var klicks = 0, start = Date.now();
    (function tick() {
      if (isOpen()) return;                               // offen -> fertig, nie nachklicken
      var gewartet = Date.now() - start;
      if (gewartet > AUFGEBEN_NACH) { fallback(btn); return; }
      // Erster Klick sofort, jeder weitere erst nach KLICK_ABSTAND ohne Erfolg.
      // Ist der Activator noch nicht da (Widget lädt), zählt das NICHT als Klick.
      if (klicks < MAX_KLICKS && (klicks === 0 || gewartet >= klicks * KLICK_ABSTAND)) {
        var a = activator();
        if (a) { a.click(); klicks++; }
      }
      setTimeout(tick, 150);
    })();
  }
  function bind(root) {
    (root || document).querySelectorAll('[data-bl-openchat]').forEach(function (b) {
      if (b.dataset.blOpenchatBound) return;
      b.dataset.blOpenchatBound = '1';
      b.addEventListener('click', function () { openChat(b); });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bind(); });
  } else {
    bind();
  }
  /* Theme-Editor: neu gerenderte Sections nachbinden. */
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
})();
